<template>
  <div>
    <div>
      <b-form-group :label="$t('message.Название') + ':'" label-for="Name">
        <b-form-input id="Name" type="text" v-model="model.name" required>
        </b-form-input>
      </b-form-group>
    </div>
  </div>
</template>
<script>
export default {
  name: "RoleForm",
  props: ["model"],
  data() {
    return {
      packages: []
    };
  },
  created: function() {
    let promise = this.$noname.get("role");

    return promise
      .then(data => {
        this.role = data.data.items;
      })
      .catch(this.$noname.HandleError);
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/modules/RoleForm.vue